import { useEffect, useMemo, useState } from 'react'

import { HomePage } from './components/HomePage.jsx'
import { AuroraField } from './components/fx/AuroraField.jsx'
import { GrainVignette } from './components/fx/GrainVignette.jsx'
import { MagneticCursor } from './components/fx/MagneticCursor.jsx'
import { DetailPage } from './components/layout/DetailPage.jsx'
import { Footer } from './components/layout/Footer.jsx'
import { Header } from './components/layout/Header.jsx'
import { useCinemaTimeline } from './hooks/useCinemaTimeline.js'
import { usePageMeta } from './hooks/usePageMeta.js'
import { useReducedMotion } from './hooks/useReducedMotion.js'
import { detectPreferredLocale, getLocalizedPath, getRouteMeta, resolveRoute } from './lib/routing.js'

export function App() {
  const [pathname, setPathname] = useState(() => window.location.pathname)
  const reducedMotion = useReducedMotion()
  const route = useMemo(() => resolveRoute(pathname), [pathname])
  const meta = useMemo(() => getRouteMeta(pathname), [pathname])

  usePageMeta(meta)
  useCinemaTimeline(!reducedMotion, pathname)

  useEffect(() => {
    if (window.location.pathname === '/') {
      const locale = detectPreferredLocale(navigator.language)
      window.history.replaceState({}, '', getLocalizedPath(locale, 'home'))
      setPathname(window.location.pathname)
    }

    const onClick = (event) => {
      const anchor = event.target.closest('a[href^="/"]')
      if (!anchor || anchor.target || anchor.hasAttribute('download')) return
      const url = new URL(anchor.href)
      if (url.origin !== window.location.origin) return
      event.preventDefault()
      window.history.pushState({}, '', url.pathname)
      setPathname(url.pathname)
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' })
    }
    const onPopState = () => setPathname(window.location.pathname)

    document.addEventListener('click', onClick)
    window.addEventListener('popstate', onPopState)
    return () => {
      document.removeEventListener('click', onClick)
      window.removeEventListener('popstate', onPopState)
    }
  }, [reducedMotion])

  return (
    <>
      <AuroraField reducedMotion={reducedMotion} />
      <GrainVignette reducedMotion={reducedMotion} />
      <MagneticCursor reducedMotion={reducedMotion} />
      <div className="app-shell">
        <Header locale={route.locale} slug={route.slug} />
        {route.slug === 'home' ? (
          <HomePage locale={route.locale} reducedMotion={reducedMotion} />
        ) : (
          <DetailPage locale={route.locale} slug={route.slug} />
        )}
        <Footer locale={route.locale} reducedMotion={reducedMotion} />
      </div>
    </>
  )
}
